import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import '../styles/landing.css';

const PaymentCancel = () => {
  return (
    <div className="landing-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: '600px', padding: '2rem' }}>
        <div className="display-large" style={{ marginBottom: '1rem' }}>Payment Cancelled</div>
        <p className="body-large" style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '2rem' }}>
          No worries — your prebook deposit was not charged. Come back anytime to reserve your R-Series watch.
        </p>
        <a href="/">
          <Button className="btn-primary btn-large">
            Back to Home <ArrowRight className="ml-2" size={20} />
          </Button>
        </a>
      </div>
    </div>
  );
};

export default PaymentCancel;
